<template>
  <div>
    <h1 class="title">{{ $t("entity.organization") }}</h1>

    <department-boxes />
    <process-boxes />
    <datasource-boxes />
    <data-category-boxes />
    <data-boxes />
    <datasubject-boxes />
    <datasubject-boxes-for-datasource />
  </div>
</template>

<script>
import DataBoxes from "./component/data-boxes";
import DataCategoryBoxes from "./component/data-category-boxes";
import DatasourceBoxes from "./component/datasource-boxes";
import DatasubjectBoxes from "./component/datasubject-boxes";
import DatasubjectBoxesForDatasource from "./component/datasubject-boxes-for-datasource.vue";
import DepartmentBoxes from "./component/department-boxes";
import ProcessBoxes from "./component/process-boxes";
export default {
  components: {
    DepartmentBoxes,
    ProcessBoxes,
    DatasourceBoxes,
    DataCategoryBoxes,
    DataBoxes,
    DatasubjectBoxes,
    DatasubjectBoxesForDatasource,
  },

  beforeDestroy() {
    this.$store.commit("entityBoxes/clear");
  },
};
</script>

<style lang="scss" scoped>
@import url("./organization-entities-view.scss");
</style>
